var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_2114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.267 192.341C171.144 192.341 196.175 167.31 196.175 136.433C196.175 105.556 171.144 80.5254 140.267 80.5254C109.39 80.5254 84.3594 105.556 84.3594 136.433C84.3594 167.31 109.39 192.341 140.267 192.341Z",
    fill: "#0E6DB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1736 56.6753C41.4705 56.6753 49.0073 49.1385 49.0073 39.8416C49.0073 30.5445 41.4705 23.0078 32.1736 23.0078C22.8766 23.0078 15.3398 30.5445 15.3398 39.8416C15.3398 49.1385 22.8766 56.6753 32.1736 56.6753Z",
    fill: "#0E6DB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6975 92.0293V61.3527H107.367V53.6836H15.3371V61.3527H23.0062V92.0293H7.66797V99.6984H115.036V92.0293H99.6975ZM46.0136 92.0293H30.6754V61.3527H46.0136V92.0293ZM53.6828 92.0293V61.3527H69.021V92.0293H53.6828ZM92.0284 92.0293H76.6902V61.3527H92.0284V92.0293Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.706 107.367H0V115.036H122.706V107.367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.673 38.8066L63.1548 8.13007C62.0427 7.51654 60.6623 7.51654 59.5503 8.13007L2.03178 38.8066C0.459604 39.6118 -0.307309 41.4141 0.114493 43.1013C0.536295 44.8269 2.07012 46.0156 3.83402 46.0156H118.871C120.635 46.0156 122.169 44.8269 122.591 43.1013C123.012 41.4141 122.245 39.6118 120.673 38.8066ZM19.1723 38.3464L61.3525 15.8375L103.533 38.3464H19.1723Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_2114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122.706,
    height: 122.706,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/Bank.679b0e3f45f1310e56f1fdee38402348.svg";
export { ForwardRef as ReactComponent };